<div class="layout__inner-card">
  <h4>Insurance Activity Index</h4>
  @if (data.length > 0) {
    <p-table [rowHover]="true" [value]="data">
      <ng-template pTemplate="header">
        <tr class="table-section__thead">
          <th pSortableColumn="date" i18n
            >Date
            <p-sortIcon field="date"></p-sortIcon>
          </th>
          <th i18n>Symbole<br />MIB</th>
          <th i18n>Endroit de<br />résidence</th>
          <th i18n>Raison de<br />la requête</th>
          <th i18n>Secteur<br />d'activité</th>
          <th i18n>Type<br />d'assureur</th>
          <th i18n>Formulaire<br />de police</th>
          <th i18n>Type du<br />producteur</th>
          <th i18n>Couverture</th>
          <th i18n>Type de<br />devise</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-tableEntry>
        <tr>
          <td>{{ tableEntry.submissionDate }}</td>
          <td>{{ tableEntry.carrierCode }}</td>
          <td>{{ getResidencePlace(tableEntry) }}</td>
          <td>{{ (tableEntry.inquiryReason?.replace('_', ' ') | titlecase) || '' }}</td>
          <td>{{ (tableEntry.lineOfBusiness?.replace('_', ' ') | titlecase) || '' }}</td>
          <td>{{ (tableEntry.carrierType?.replace('_', ' ') | titlecase) || '' }}</td>
          <td>{{ (tableEntry.policyForm?.replace('_', ' ') | titlecase) || '' }}</td>
          <td>{{ (tableEntry.producerType?.replace('_', ' ') | titlecase) || '' }}</td>
          <td>{{ (tableEntry.policyCoverage | currency: 'CAD' : 'symbol-narrow' : '1.0-0') || '' }}</td>
          <td>{{ tableEntry.currencyType }}</td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <p i18n>Aucun code</p>
  }
</div>
